module.exports = __webpack_public_path__ + "img/ass_result_icon_7.37fbbfd6.png";